<template>
  <component
    :is="props.external ? 'a' : Link"
    :href="props.href"
    :target="props.external ? '_blank' : null"
    class="text-sm leading-6 text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
  >
    <slot />
  </component>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps({
  href: String,
  external: Boolean,
})
</script>
